import React, { useEffect, useState } from "react";
import { Bell, BellRing, Briefcase, Inbox, LogOut, Megaphone, Monitor, Wallet, Trash2 } from "lucide-react";
import { Notifications } from "./Notifications";
import { Evenements } from "./Evenements";
import { Sparkles } from "lucide-react";
import { api } from "../console/api";
import { Groupe, Ligne, TitreGroupe, Retour, Badge } from "../espace/ui";
import { Argent } from "./Argent";
import { ProfsMobile } from "./ProfsMobile";
import { Alertes, Messages } from "./ATraiter";
import { dateCourte, iso } from "./outils";

/* Un message pour toutes les familles, affiché en haut de leur application (cours annulé,
   rappel, événement) pendant la période choisie. */
const Annonce = () => {
  const auj = iso(new Date());
  const [form, setForm] = useState({ titre: "", texte: "", du: auj, au: auj });
  const [liste, setListe] = useState([]);
  const [message, setMessage] = useState("");
  const [envoi, setEnvoi] = useState(false);
  // Une annonce sans date de fin reste affichée : elle compte parmi celles en cours.
  const charger = () => api("/application").then((d) => setListe((d.annonces || []).filter((a) => !a.au || a.au >= auj))).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { charger(); }, []);
  const publier = async () => {
    if (envoi) return;
    setMessage("");
    setEnvoi(true);
    try {
      await api("/application/annonces", { method: "POST", body: JSON.stringify({ ...form, actif: true }) });
      setForm({ titre: "", texte: "", du: auj, au: auj });
      setMessage("Publié : les familles le voient en ouvrant l'application.");
      charger();
    } catch (e) { setMessage(e.message); }
    finally { setEnvoi(false); }
  };
  const retirer = async (a) => {
    if (!window.confirm(`Retirer « ${a.titre} » ?`)) return;
    await api(`/application/annonces/${a.id}`, { method: "DELETE" });
    charger();
  };
  return (
    <div className="space-y-5" data-testid="ecole-annonce">
      <Groupe>
        <div className="p-4 space-y-3">
          <input className="input-field w-full" placeholder="Titre (ex. Cours de hip-hop annulé ce soir)" value={form.titre}
            onChange={(e) => setForm({ ...form, titre: e.target.value })} data-testid="ecole-annonce-titre" />
          <textarea className="input-field w-full" rows={4} placeholder="Le message (facultatif)" value={form.texte}
            onChange={(e) => setForm({ ...form, texte: e.target.value })} />
          <div className="grid grid-cols-2 gap-2 text-[12.5px] text-[var(--muted)]">
            <label>Du<input type="date" className="input-field w-full mt-1" value={form.du} onChange={(e) => setForm({ ...form, du: e.target.value })} /></label>
            <label>Au<input type="date" className="input-field w-full mt-1" value={form.au} min={form.du} onChange={(e) => setForm({ ...form, au: e.target.value })} /></label>
          </div>
          <button className="btn-primary w-full justify-center" disabled={!form.titre.trim() || envoi} onClick={publier}
            data-testid="ecole-annonce-publier">{envoi ? "Publication…" : "Publier dans l'application"}</button>
          {message && <p className="text-[13px] text-[var(--muted)]">{message}</p>}
        </div>
      </Groupe>
      {liste.length > 0 && (
        <section>
          <TitreGroupe>En cours ou à venir</TitreGroupe>
          <Groupe>
            {liste.map((a) => (
              <div key={a.id} className="flex items-start justify-between gap-3 px-4 py-3">
                <div className="min-w-0">
                  <div className="text-[15px]">{a.titre}</div>
                  <div className="text-[12px] text-[var(--muted)]">{dateCourte(a.du)} → {dateCourte(a.au)}</div>
                </div>
                <button onClick={() => retirer(a)} aria-label="Retirer" className="w-9 h-9 grid place-items-center rounded-full" style={{ color: "#DC2626" }}>
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </Groupe>
        </section>
      )}
    </div>
  );
};

const ECRANS = {
  argent: { titre: "Impayés et relances", Composant: Argent },
  profs: { titre: "Profs", Composant: ProfsMobile },
  alertes: { titre: "Toutes les alertes", Composant: Alertes },
  annonce: { titre: "Message aux familles", Composant: Annonce },
  notifications: { titre: "Notifications", Composant: Notifications },
  evenements: { titre: "Stages, workshops & événements", Composant: Evenements },
  messages: { titre: "Messages", Composant: Messages },
};

export const Plus = ({ cible, resume, aller, onCompte, onQuitter, choixEspace, nouvelleBarre = false }) => {
  const [ecran, setEcran] = useState(cible?.ecran || "");
  // Un écran qui ouvre lui-même une fiche (un stage, une audition) a son propre « Retour » :
  // on cache alors celui de « Plus », sinon deux boutons Retour s'empilent.
  const [detail, setDetail] = useState(false);
  useEffect(() => { setEcran(cible?.ecran || ""); }, [cible]);
  if (ecran && ECRANS[ecran]) {
    const { titre, Composant } = ECRANS[ecran];
    return (
      <div className="space-y-4">
        {!detail && <Retour onClick={() => setEcran("")} label="Plus" />}
        {!detail && <div className="font-display text-[24px] leading-tight">{titre}</div>}
        <Composant groupe={cible?.groupe} aller={aller} onCompte={onCompte} cible={cible} onDetail={setDetail} />
      </div>
    );
  }
  const r = resume || {};
  return (
    <div className="space-y-6" data-testid="ecole-plus">
      <Groupe>
        <Ligne Icone={Sparkles} couleur="#EC4899" titre="Stages, workshops & événements" sousTitre="Stages des vacances, workshops heels, auditions, spectacles"
          onClick={() => setEcran("evenements")} testId="ecole-plus-evenements" />
        {/* Nouvelle barre (test d'abord) : Profs et Factures sont des onglets, Messages vient ici. */}
        {nouvelleBarre ? (
          <Ligne Icone={Inbox} couleur="#0284C7" titre="Messages" sousTitre="Formulaires du site, à traiter"
            badge={r.messages ? <Badge>{r.messages}</Badge> : null} onClick={() => setEcran("messages")} testId="ecole-plus-messages" />
        ) : (
          <>
            <Ligne Icone={Wallet} couleur="#F59E0B" titre="Impayés et relances" sousTitre="L'argent du semestre, relancer les familles"
              badge={r.impayes ? <Badge couleur="#F59E0B">{r.impayes}</Badge> : null} onClick={() => setEcran("argent")} testId="ecole-plus-argent" />
            <Ligne Icone={Briefcase} couleur="#9333EA" titre="Profs" sousTitre="Remplaçants, décomptes du mois à valider"
              badge={r.profs_sans_remplacant ? <Badge>{r.profs_sans_remplacant}</Badge> : null} onClick={() => setEcran("profs")} testId="ecole-plus-profs" />
          </>
        )}
        <Ligne Icone={Megaphone} couleur="#00A8AF" titre="Message aux familles" sousTitre="Affiché en haut de leur application"
          onClick={() => setEcran("annonce")} testId="ecole-plus-annonce" />
        <Ligne Icone={BellRing} couleur="#DC2626" titre="Notifications sur ce téléphone" sousTitre="Être prévenu·e des inscriptions et messages"
          onClick={() => setEcran("notifications")} testId="ecole-plus-notifications" />
        <Ligne Icone={Bell} couleur="#64748B" titre="Toutes les alertes de la console"
          badge={r.a_traiter ? <Badge couleur="#64748B">{r.a_traiter}</Badge> : null} onClick={() => setEcran("alertes")} testId="ecole-plus-alertes" />
      </Groupe>
      <Groupe>
        <Ligne Icone={Monitor} couleur="#0F1B2D" titre="Ouvrir la console complète" sousTitre="Facturation, imports, réglages (mieux sur ordinateur)"
          href="/console" testId="ecole-plus-console" />
        {choixEspace}
      </Groupe>
      <Groupe>
        <Ligne Icone={LogOut} couleur="#DC2626" titre="Me déconnecter" danger fleche={false} onClick={onQuitter} testId="ecole-deconnexion" />
      </Groupe>
    </div>
  );
};
